import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './components/hooks/IsAuth';
import { Provider } from 'react-redux';
import { store } from './store/store';
import ReactGA from 'react-ga4';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const MEASUREMENT_ID = "G-9VQ7QX7HKF"; 
ReactGA.initialize(MEASUREMENT_ID)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
        <Provider store={store}>
            <AuthProvider>
                <ToastContainer />
                <App />
            </AuthProvider>
        </Provider>
    </>


);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
// serviceWorkerRegistration.register();
